export default __webpack_public_path__ + "static/media/UniversLTStd-XBlack.e20faa1f.otf";